import Vue from 'vue';
import Vuex from 'vuex';

// Vuex modules
import session from './session';
import school from './school';
import academicLevels from './academicLevels';
import languages from './languages';
import teachers from './teachers';
import schools from './schools';
import persistent from './persistent';
import admin from './admin';
import ui from './ui';

// Persistence
// https://github.com/championswimmer/vuex-persist
import createPersistedState from 'vuex-persistedstate';

const persistenceOptions = {
	key: process.env.APP_CODE + '-vuex-persist',
	paths: ['persistent']
};

Vue.use(Vuex);

const store = new Vuex.Store({
	modules: {
		session,
		school,
		academicLevels,
		languages,
		teachers,
		schools,
		persistent,
		admin,
		ui
	},
	plugins: [createPersistedState(persistenceOptions)]
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js